/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import moment from 'moment';
import { DownloadIcon, ViewIcon } from '../../../../../assets/icons';
import { Constants, fromStorage, getUpdatedState } from '../../../../../utils';
import { Input, Modal, Pagination } from '../../../../../components';
import { OrdersService } from '../../../../../services';
import ModalDetails from "./modal-details";

const Finished = () => {
  const [selectedItem, setSelectedItem] = useState();
  const { data, downloadAll, downloadItem, filters, goToPage, onChange, pagination, reload, search } = useFetchTable();

  return (
    <main className="w-full">
      <Modal isOpen={!!selectedItem} onClose={() => setSelectedItem(null)}>
        {!!selectedItem && (
          <ModalDetails date={selectedItem} onClose={() => setSelectedItem(null)} />
        )}
      </Modal>

      <div className="flex flex-wrap items-end gap-3">
        <Input
          className={{ base: 'max-w-44' }}
          type="date"
          label="Desde"
          value={filters.since}
          onValueChange={v => onChange('since', v)}
        />

        <Input
          className={{ base: 'max-w-44' }}
          type="date"
          label="Hasta"
          value={filters.until}
          onValueChange={v => onChange('until', v)}
        />

        <div className="flex gap-4">
          <button
            className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
            onClick={search}
          >
            Filtrar
          </button>
          <button
            className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
            onClick={() => reload()}
          >
            Limpiar
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">
            <span>Historial de viajes finalizados</span> 
          </p>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-sm text-default font-semibold align-bottom">
                <th className="pl-4">Fecha del viaje</th>
                <th>Viajes finalizados</th>
                <th align="right">Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>{ moment(item?.date).format('DD/MM/YYYY') }</td>
                  <td><span className="font-semibold">{ item?.count }</span></td>
                  <td>
                    <div className="flex items-center justify-end gap-4">
                      <img
                        src={ViewIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => setSelectedItem(item.date)}
                        alt=""
                      />

                      <Link
                        to={`/report/finished/${item.date}/duplicate`}
                        className="bg-green text-white px-3 py-1 rounded-lg font-semibold"
                      >
                        Duplicar
                      </Link>

                      <img
                        src={DownloadIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => {
                          toast.promise(downloadItem(item), {
                            loading: 'Descargando...',
                            success: 'Reporte descargado con éxito',
                            error: 'Error al descargar el reporte',
                          });
                        }}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    plaque: '',
    since: '',
    until: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await OrdersService.moderator.findAllFinished(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await OrdersService.moderator.downloadAllFinished(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadItem = async (item) => {
    try {
      const response = await OrdersService.moderator.downloadAllFinished({ date: item.date });
      if (response.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      toast.error(String(error));
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    downloadAll,
    downloadItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
  }
}

export default Finished;